import { FC } from "react"
import { useErrors } from "src/context/errors";
import styled from "styled-components";

interface Props {
  errorCode: string;
}
export const ValidationErrorMessage: FC<Props> = ({ errorCode }) => {
  const { hasError, getErrorMessage } = useErrors()

  return (
    <div data-error-code={errorCode}>
      {
        !!hasError(errorCode) &&
        <ValidationErrorMessageWrapper>{
          getErrorMessage(errorCode)
        }</ValidationErrorMessageWrapper>
      }
    </div>
  )
}
const ValidationErrorMessageWrapper = styled.div`
  whiteSpace: normal;
  color: #E84242;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
`